import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Bell, AlertTriangle, CheckCircle2 } from "lucide-react";

export default function Notifications() {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => { api.get("/dashboard/stats").then(r => setAlerts(r.data.alerts || [])); }, []);

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div>
        <div className="text-overline">Veille</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{fontFamily:'Outfit'}}>Notifications</h1>
        <p className="text-sm text-zinc-500 mt-1">Alertes actives</p>
      </div>

      <Card className="card-flat p-6">
        <div className="space-y-2">
          {alerts.length === 0 && (
            <div className="text-center py-10">
              <CheckCircle2 className="w-10 h-10 mx-auto text-emerald-500 mb-3" />
              <div className="font-medium">Tout est en ordre</div>
              <div className="text-sm text-zinc-500 mt-1">Aucune alerte active.</div>
            </div>
          )}
          {alerts.map((a, i) => {
            const Icon = a.severity === "danger" ? AlertTriangle : Bell;
            return (
              <div key={i} className={`flex items-start gap-3 p-3 rounded-md border ${a.severity === "danger" ? "bg-red-50 border-red-100" : "bg-amber-50 border-amber-100"}`} data-testid={`notif-${i}`}>
                <Icon className={`w-4 h-4 mt-0.5 ${a.severity === "danger" ? "text-red-600" : "text-amber-600"}`} />
                <div>
                  <div className="text-sm font-medium">{a.message}</div>
                  <div className="text-xs text-zinc-500 mt-0.5 uppercase tracking-wider">{a.type}</div>
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
